import { useState } from 'react';

const useCopyToClipboard = () => {
    const [copyTooltip, setCopyTooltip] = useState<{ [key: string]: string }>(
        {}
    );

    const copyToClipboard = (value: string) => {
        navigator.clipboard.writeText(value);
    };

    const copyLink = (id?: string, value?: string) => {
        if (!id || !value) {
            return;
        }
        setCopyTooltip({
            [id]: 'Copied!',
        });
        copyToClipboard(value);
    };

    return {
        copyTooltip,
        copyLink,
    };
};

export default useCopyToClipboard;
